import { render, staticRenderFns } from "./RefuRecom.vue?vue&type=template&id=9d351bba"
import script from "./RefuRecom.vue?vue&type=script&lang=js"
export * from "./RefuRecom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports